module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av575-9a6ee6ef1235b6fe9e6ee8770439aceb.jpg";